<template>
    <div class="container-fluid px-0 reports-tab-nav px-3">


        <div class="row no-gutters py-2 mb-3">
            <div class="col-sm-6 pl-0">
                <div class="company-form-box-title custom-search">
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="col-sm-6 cursor-pointer text-right company-form-box-title pr-0">
                <b-button id="show-btn" v-if="ce" @click="addNew()"><b-icon icon="plus" ></b-icon> Add Role</b-button>
            </div>
        </div>


        <table class="table dataTable">
            <thead>
                <tr class="table-head">
                    <td>Name</td>
                    <td class="">Action</td>
                </tr>
            </thead>
            <tbody>
                <tr class="hover-bg table-row border-bottom mx-2" v-for="(role , n) in paginatedData" :key="role.id">
                    <td class="col-md-5 align-middle list-columns">{{role.name}} <span v-if="role.is_default != 0">(default)</span></td>

                    <td class="clearfix col-md-6 align-middle" >
                        <div class="float-right mr-2 position-relative" >
                            <b-button-toolbar>
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                    <b-button-group class="mr-0" v-if="role.is_default == 0" >
                                        <b-button class="mr-3 rounded edit-btn" title="Edit Role" @click="editRole(role.id)" >
                                            <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                        </b-button>

                                        <b-button class="mr-3 rounded edit-btn" title="Role Resources" @click="roleResources(role.id , role.name , false)">
                                            <b-icon icon="layers" class="mr-2" aria-hidden="true" ></b-icon>Resources
                                        </b-button>
                                    </b-button-group>
                                    <b-button-group class="mr-0" v-else >
                                        <b-button class="mr-3 rounded edit-btn" title="Default Role" @click="roleResources(role.id , role.name , true)">
                                            <b-icon icon="layers" class="mr-2" aria-hidden="true" title="Default"></b-icon>Resources
                                        </b-button>
                                    </b-button-group>
                                </div>
                            </b-button-toolbar>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
        <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav></div>




        <b-modal id="bv-modal-role" size="lg" hide-footer title="Add Role" v-if="this.ce">
            <b-overlay :show="showoverlay" rounded="sm">
                <b-form @submit.stop.prevent="onSubmit">
                    <div class="clearfix">
                        <div class="px-3">
                            <input type="hidden" v-model="fdata.id" name="id">

                            <b-form-group id="name-group" label="Role Name" class="required-field" label-for="name">
                                <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Role Name"></b-form-input>
                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                            </b-form-group>

                            <label style="opacity: 0;">label</label>
                            <div class="text-center">
                                <b-button v-if="fdata.id > 0" type="submit" variant="success" class="btn-primary"><b-icon variant="light" icon="pencil" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Edit Role</b-button>
                                <b-button v-else type="submit" variant="success" class="btn-primary"><b-icon variant="light" icon="plus-circle" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Add Role</b-button>
                            </div>
                        </div>
                    </div>
                </b-form>
            </b-overlay>
        </b-modal>

        <b-modal id="bv-modal-role-resource" size="lg" hide-footer :title="'Role Resource for ' + role_title">
            <role-resource :role_id="this.role_id"  :disabled="disabled"></role-resource>
        </b-modal>


    </div>
</template>


<script>
    export default{

        mounted() {

        },
        props: [ ],
        data(){

            return {

                roles:[],
                fdata: {name:null , id:null},
                rdata: {name:null , id:null},
                showoverlay:false,
                showoverlay_list:false,


                role_title : '',
                role_id : null,

                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},

                ce : true,
                disabled : false,
            }
        },
        methods:{


            addNew(x)
            {
                this.addtype = x;
                this.resetForm();
                this.$bvModal.show('bv-modal-role');

            },
            getRoleData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/acl/role/agent' , {
                    params: {

                    }
                }).then(function(response){
                    this.roles = response.data;

                }.bind(this)).catch(function (error){
                    //currentObj.serverError(error);
                    });
            },
            editRole:function(x)
            {
                this.addtype = false;
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.showoverlay = true;
                axios.get(this.$api_url+'/acl/role/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.$validator.reset();
                    this.showoverlay = false;
                    this.$bvModal.show('bv-modal-role');
                }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
            roleResources:function(x , role_title , disabled)
            {
                if(!this.checkNet()) return false;

                this.role_title = role_title;
                this.role_id = x;
                this.disabled = disabled;
                this.$bvModal.show('bv-modal-role-resource');

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {name:null, id:null};

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/acl/role/agent', formData)
                                .then(function (response)
                                {
                                    //console.log(response.data);
                                    this.getRoleData();


                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                    this.resetForm();
                                    //this.movenext = true;
                                    //this.showMessage();
                                    this.$bvModal.hide('bv-modal-role');

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                });
                });
            },

        },
        created: function(){
            this.getRoleData();
            Fire.$on('reloadUsers', () => {this.getRoleData()});
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.roles;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
